import axiosConfig from "./axiosConfig";
import { LeadCandidate } from "./postLeadSearch";

export interface VoaRefetchDegradedResponse {
  candidates: LeadCandidate[];
}

// Bulk variant of postVoaRefetch: takes a list of source refs and on
// the BE clears only the caches/timestamps tied to each row's
// `enrichmentDegradedSources`. Use this when a search produced rows
// flagged with missing data (upstream rate-limited/timed-out) and the
// operator wants to retry just those sources without paying for a
// full per-row refetch.
const postVoaRefetchDegraded = async (
  authToken: string,
  sourceRefs: string[]
): Promise<VoaRefetchDegradedResponse> => {
  const { data } = await axiosConfig.post(
    "/leads/voa-refetch-degraded",
    { sourceRefs },
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postVoaRefetchDegraded;
